import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Router } from '@angular/router';
import { ReportingService } from '../reporting.service';
import { MatTableDataSource,MatDialogRef, MatPaginator, MatDialog,MAT_DIALOG_DATA } from '@angular/material';

import { Angular2Csv } from 'angular2-csv';
import { Ekpayuser } from '../../user/user';
import { LoaderService } from '../../shared/loader/loader.service';
import { RefundRequestRequestData, RefundRequest, RefundRequestView ,RefundRequestUpdateStatusRequest,RefundRequestUpdateStatusResponse } from '../refund-request/refund-request';
import { TranslateService } from '../../../../node_modules/@ngx-translate/core';
import { Subscription } from '../../../../node_modules/rxjs';
import { DataStorageService } from '../../shared/data-storage.service';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { TransactionLogs, ViewTransactionLogs } from '../../logs/transaction-logs/view-transaction-logs';
import { TransactionService } from '../../logs/transaction-logs/transaction.service';


@Component({
  selector: 'app-refund-request',
  templateUrl: './refund-request.component.html',
  styleUrls: ['./refund-request.component.css']
})
export class RefundRequestComponent implements OnInit {

  refundRequestRequestData: RefundRequestRequestData;
  refundRequestView: RefundRequestView;
  refundRequestUpdateStatusRequest: RefundRequestUpdateStatusRequest;
  refundRequestUpdateStatusResponse: RefundRequestUpdateStatusResponse;
  flagMsg: boolean = false;
  flagDataTable: boolean = false;
  maxDate: Date;
  loginUser: Ekpayuser;
  from_Date: string;
  to_Date: string;
  ture: any;
  finalToDate: Date;
  finalMinDate: Date;


  displayedColumns = ['merchant_trnx_id', 'ekpay_trnx_id', 'amount'
  , 'requested_on', 'refunded_on', 'status','action'];


  dataSource = new MatTableDataSource<RefundRequest>([]);
  refund_status: string;
  descoPrepaidReconciliation: RefundRequest;
  transactionLogs: TransactionLogs;
  viewTransactionLogs: ViewTransactionLogs;

  constructor(
    private reportingService: ReportingService,
    private logger: NGXLogger,
    private router: Router,
    private loaderService: LoaderService,
    private dataStorage: DataStorageService,
    private readonly translate: TranslateService,
    private dialog: MatDialog,
    private transactionService: TransactionService,
  ) { }
  subscription: Subscription;
  lang: string;

  ngOnInit() {
    let year = new Date().getFullYear() - 5;
    let minDateFrom = year + "-" + '01' + "-" + '01';
    this.finalMinDate = new Date(minDateFrom);
    this.subscription = this.dataStorage.langData$.subscribe((data) => {
      //this.logger.debug('data lang is ' + data);
      this.lang = data;
      if (this.lang == '' || this.lang == null) {
        this.lang = localStorage.getItem("lang");
      }
      this.translate.use(this.lang);
    })
    window.scroll(0, 0);
    this.loginUser = JSON.parse(localStorage.getItem("sessuser"));
    this.maxDate = new Date();
    this.refundRequestRequestData = new RefundRequestRequestData();
    this.refundRequestUpdateStatusRequest = new RefundRequestUpdateStatusRequest();
    this.refundRequestUpdateStatusResponse = new RefundRequestUpdateStatusResponse();
    this.transactionLogs = new TransactionLogs();
    this.refundRequestView = new RefundRequestView();

  }
  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.dataSource.filter = filterValue;
    this.flagMsg = this.dataSource.filteredData.length == 0 ? true : false;
  }

  limitOfTo() {
    let m;
    let d;
    let y;
    let nM;
    let nD;
    let nY;
    let maxDateForTo;
    m = new Date(this.from_Date).getMonth() + 1;
    d = new Date(this.from_Date).getDate();
    y = new Date(this.from_Date).getFullYear();
    if ((m == 1 || m == 3 || m == 8) && d == 31) {
      nM = m + 3;
      nD = 30;
      nY = y;
      maxDateForTo = nY + "-" + nM + "-" + nD;
      this.finalToDate = new Date(maxDateForTo);
    }
    else if ((m == 1 || m == 3 || m == 8) && d != 31) {
      nM = m + 3;
      nD = d;
      nY = y;
      maxDateForTo = nY + "-" + nM + "-" + nD;
      this.finalToDate = new Date(maxDateForTo);
    }
    else if (m == 2 || m == 4 || m == 9 || m == 5 || m == 6 || m == 7) {
      nM = m + 3;
      nD = d;
      nY = y;
      maxDateForTo = nY + "-" + nM + "-" + nD;
      this.finalToDate = new Date(maxDateForTo);
    }
    else if (m == 10) {
      nM = 1;
      nD = d;
      let year = y + 1;
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + "-" + nM + "-" + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
    else if (m == 11 && (d == 30 || d == 29)) {
      nM = 2;
      // nD = 28;
      let year = y + 1;
      let isLeap = false;

      if (year % 4 == 0) {
        if (year % 100 == 0) {
          if (year % 400 == 0)
            isLeap = true;
          else
            isLeap = false;
        }
        else
          isLeap = true;
      }
      else {
        isLeap = false;
      }

      if (isLeap == true) {
        nD = 29;
      }
      else {
        nD = 28;
      }
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + "-" + nM + "-" + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
    else if (m == 11 && !(d == 30 || d == 29)) {
      nM = 2;
      nD = d;
      let year = y + 1;
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + "-" + nM + "-" + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
    else if (m == 12) {
      nM = 3;
      nD = d;
      let year = y + 1;
      if (year > new Date().getFullYear()) {
        nY = y;
        this.finalToDate = new Date();
      } else {
        nY = year;
        maxDateForTo = nY + "-" + nM + "-" + nD;
        this.finalToDate = new Date(maxDateForTo);
      }
    }
  }

  getRefundRrequestReport(objDate1, objDate2) {
    //this.logger.debug("DESCO prepaid reconciliation report...");
    this.loaderService.show();
    let mm1 = new Date(objDate1).getMonth() + 1;
    let mm2 = new Date(objDate2).getMonth() + 1;
    this.refundRequestRequestData.from_date = new Date(objDate1).getFullYear() + "-" + mm1 + "-" + new Date(objDate1).getDate();
    this.refundRequestRequestData.to_date = new Date(objDate2).getFullYear() + "-" + mm2 + "-" + new Date(objDate2).getDate();
    //  this.refundRequestRequestData.mode = 'Web';
    this.reportingService.getRefundRequestListByDates(this.refundRequestRequestData.from_date, this.refundRequestRequestData.to_date).subscribe((data) => {
      this.flagDataTable = true;
      this.loaderService.hide();
      this.refundRequestView = data.body as RefundRequestView;
      this.flagMsg = !this.refundRequestView.data ? true : false;
      this.dataSource = new MatTableDataSource<RefundRequest>(this.refundRequestView.data);
      setTimeout(() => this.dataSource.paginator = this.paginator);
    })
  }
  @ViewChild(MatPaginator) paginator: MatPaginator;


  exportData() {
    //this.logger.debug("dwonload CSV file for DESCO prepaid reconciliation ..........")
    let options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      headers: [
        'Merchant Transaction Id',
        'Ekpay Transaction Id',
        'Amount',
        'Requested On',
        'Refunded On',
        'Status'

      ],

    };
    new Angular2Csv(this.refundRequestView.data, 'Refund_reuest_Report', options);
  }

  addWaterMark(doc) {
    var totalPages = doc.internal.getNumberOfPages();
    var i;
    for (i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setTextColor(150);
      doc.text(15, doc.internal.pageSize.height - 5, 'Ekpay Generated Report');
      doc.text(doc.internal.pageSize.width - 38, doc.internal.pageSize.height - 5, 'Page (' + i + ' of ' + totalPages + ')');
    }

    return doc;
  }

  savePDF(from_Date, to_Date) {
    this.loaderService.show();
    let head = [
      [
        'Merchant Transaction Id',
        'Ekpay Transaction Id',
        'Amount',
        'Requested On',
        'Refunded On',
        'Status'
      ]
    ]

    var data = [];

    this.refundRequestView.data.forEach(obj => {
      var arr = [];

      //arr.push(obj.secure_token);
      arr.push(obj.merchant_trnx_id);
      arr.push(obj.ekpay_trnx_id);
      arr.push(obj.amount);
      arr.push(obj.requested_on);
      arr.push(obj.refunded_on);
      arr.push(obj.status);

      data.push(arr);
    });

    // var doc = new jsPDF('l', 'mm', 'a3');
    var doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: [550, 375]
    });

    doc.setFontSize(18);
    doc.setTextColor(50);
    var headerText = "Ekpay Refund Request Report";
    var textWidth = doc.getStringUnitWidth(headerText) * doc.getFontSize() / doc.internal.scaleFactor;
    var textOffset = (doc.internal.pageSize.width - textWidth) / 2;
    doc.text(headerText, textOffset, 25);
    doc.text("_____________________________", textOffset, 28);

    doc.setFontSize(12);
    doc.setTextColor(150);

    var curDate = new Date();
    var text = "Generated on: " + curDate.getDate() + "/" + (curDate.getMonth() + 1) + "/" + curDate.getFullYear() + " " + curDate.getHours() + ":" + curDate.getMinutes();
    doc.text(text, doc.internal.pageSize.width - 76, 37);

    let mm1 = new Date(from_Date).getMonth() + 1;
    let mm2 = new Date(to_Date).getMonth() + 1;
    let from_date = new Date(from_Date).getDate() + "/" + mm1 + "/" + new Date(from_Date).getFullYear();
    let to_date = new Date(to_Date).getDate() + "/" + mm2 + "/" + new Date(to_Date).getFullYear();

    text = "Report Date: From " + from_date + " to " + to_date;
    doc.text(text, 15, 37);

    doc.setFontSize(9);
    doc.setTextColor(100);

    (doc as any).autoTable({
      head: head,
      body: data,
      theme: 'grid',
      startY: 40,
      styles: { fontSize: 8 },
      headStyles: {
        fillColor: [123, 49, 126]
      },
      didDrawCell: data => {
        // //console.log(data.column.index)
      }
    })

    doc = this.addWaterMark(doc);

    this.loaderService.hide();


    // below line for Open PDF document in new tab
    // doc.output('dataurlnewwindow');

    // below line for Download PDF document
    doc.save('ekpay_refund_requrest.pdf');
  }
//TODO
  openStatusDialog(message: string) {
    const dialogRef = this.dialog.open(RefundRequestStatusDialog, {
        width: '400px',
        height: '250px',
        data: {
          message: message
        }
    });
  }

  checkRefundStatus(ekpay_trnx_id: string) {

    this.refundRequestUpdateStatusRequest.ekpay_trnx_id = ekpay_trnx_id.trim();
    this.refundRequestUpdateStatusRequest.status = "PROCESSED";

    this.reportingService.updateRefundRequestStatus(this.refundRequestUpdateStatusRequest).subscribe((data) => {
      this.refundRequestUpdateStatusResponse = data.body as RefundRequestUpdateStatusResponse;
      if(this.refundRequestUpdateStatusResponse.status == null){
        //this.logger.debug("Refund Request update - null response received");
      }else{
        this.openStatusDialog(this.refundRequestUpdateStatusResponse.message);
      }
    })
  }

}

@Component({
  selector: 'refund-status-dialog',
  template: `

<div mat-dialog-content>
  <h1 mat-dialog-title style="margin-left:10px;">Refund request</h1>
</div>
<div mat-dialog-content style="margin-top: 30px; margin-bottom: 30px; margin-left: 0px;">
      <h4>{{message}}</h4>
</div>

<div mat-dialog-actions>
      <button mat-button type="button" style="background-color: #FFA728;" cdkFocusInitial (click)="close()" tabindex="-1">Close</button>
</div>
  `,
})
export class RefundRequestStatusDialog {

  message: string;

  constructor(
      public dialogRef: MatDialogRef<RefundRequestStatusDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private logger: NGXLogger,
      private dialog: MatDialog,
      private router: Router) { }

  ngOnInit() {
   this.message = this.data.message;
  }

  close(): void {
    //this.logger.debug("Refund request status check response dialog closed");
    this.dialogRef.close(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/report/refund-request/refund-request.component.ts